import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  formLabel: {
    fontSize: '1rem',
    fontWeight: 600,
    marginBottom: theme.spacing(1),
  },
  alert: {
    marginTop: theme.spacing(1),
  },
}))

export default useStyles
